import React from 'react';
import PropTypes from 'prop-types';
// common components
import FormField from './../../../common/Forms/FormField/FormField';
import Dropzone from './../../../common/Forms/Dropzone/Dropzone';

const ManageModule = ({ onDelete, value, onChange}) => {
	if(onDelete) {
		return (
			<div className='ManageModule'>
				<div>Are you sure, you want to delete?</div>
			</div>
		);
	};
	return (
		<div className='ManageModule'>
			<FormField
				label="module name"
				name="name"
				type="text"
				placeholder="enter module name"
				value={value.name}
				onChange={onChange}
				validate={['required']}
				autoFocus
                maxLength={50}
			/>
			<FormField
				label="description"
				name="description"
				type="text"
				multiline
				placeholder="enter description"
				value={value.description}
				onChange={onChange}
			/>
			{/*<Dropzone
				addedfile={(file) => console.log(file, 'filefilefilefile')}
				acceptedFiles='.jpeg,.jpg,.png'
			/>*/}
		</div>
	);
}

ManageModule.propTypes = {
	value: PropTypes.instanceOf(Object),
	onDelete: PropTypes.bool,
	onChange: PropTypes.func
};

ManageModule.defaultProps = {
	value: {},
	onDelete: false,
	onChange: () => {}
};

export default ManageModule;



// WEBPACK FOOTER //
// ./components/CourseModule/ManageModule/ManageModule.js